import React from 'react';

import { BadgeContainer, BadgeText } from './styled';

export type Status = 'pending' | 'expired';

export interface IBadgeProps {
  status: Status;
  badgeColor?: string;
  textColor?: string;
}

const statusColors: Record<Status, { textColor: string; badgeColor: string }> = {
  pending: { textColor: '#F1BF0B', badgeColor: '#4F4932' },
  expired: { textColor: '#FB6F6A', badgeColor: '#593D44' }
};

export const Badge: React.FC<IBadgeProps> = React.memo(({ status }) => {
  const colors = statusColors[status];

  return (
    <BadgeContainer badgeColor={colors.badgeColor}>
      <BadgeText textColor={colors.textColor} weight={3}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </BadgeText>
    </BadgeContainer>
  );
});
